<i class="far fa-comments" data-fa-symbol="comments"></i>

<div class="wrapper">
  <div class="table-container">
    <qm-vivo-filters (filtersChanged)="filtersChanged($event)"></qm-vivo-filters>

    <div *ngIf="noResults" class="noResults">
      <h3>{{'No results' | translate}}</h3>
    </div>

    <div class="m-custom" *ngIf="events.length > 0">
      <ul class="list-group list-group-flush list"style="padding-right: 0.5em;">
        <li *ngFor="let s of events" class="list-group-item">
          <div class="small-text" (click)="setActive(s)">
            <div class="name" *ngIf="s?.createUser">
              {{s?.createUser?.firstName + ' ' + s?.createUser?.lastName}}
            </div>
            <div class="name" *ngIf="!s?.createUser">
              {{'Default user' | translate}}
            </div>
            <!--<div *ngIf="s.priority" class="priority">
              {{s.priority.id.name}}
            </div>-->
            <div class="date">
              {{'Status' | translate}}: <span class="{{s.status}}">{{s.status | translate}}</span>
              <span>| {{s.updatedAt | qmDateDistance}}</span>
              <span *ngIf="s.date"> | {{'Duedate' | translate}}: {{s.date | date: 'dd.MM.yyyy HH:mm'}}</span>
            </div>
          </div>
          <div class="content" (click)="setActive(s)">
            <div>
              <p *ngIf="s.name">{{s?.name}}</p>
              <p *ngIf="!s.name">{{s?.message}}</p>
            </div>
            <div *ngIf="!isActive(s) && comments.get(s._id)" class="comment-counter">
              <svg class="svg-inline--fa fa-w-20">
                <use xlink:href="#comments"></use>
              </svg>
              <span class="badge badge-pill badge-success">{{comments.get(s._id).length}}</span>
            </div>
          </div>
          <!--<div class="small-text" *ngIf="s.parents.length >= 1">
            <div class="d-flex flex-row">
              <div class="name" *ngFor="let a of s.parents" style="margin-left: 0.2em;">
                {{a.name}}
              </div>
            </div>
          </div>-->
          <div class="small-text" *ngIf="s.subscribers.length > 0">
            <div class="d-flex flex-row subscribers">
              <span class="name" style="margin-left: 0.2em;" *ngFor="let a of getNames(s.subscribers)">
                {{a}}
              </span>
            </div>
          </div>
          <div class="small-text">
            <div>
              <a [href]="getTaskLink(s._id)" target="_blank">
                {{'Show in vivo' | translate}}
              </a>
            </div>
          </div>
          <div class="small-text">
            <div class="d-flex flex-row" *ngIf="s.parents.length > 0">
              <div class="name" *ngFor="let a of assetTree(s.parents[0])">
                <span>{{a}} </span>
              </div>
            </div>
          </div>
          <div class="comments" *ngIf="isActive(s) && comments.get(s._id)">
            <div *ngFor="let s2 of comments.get(s._id)" class="comment-block">
              <div class="small-text">
                <div *ngIf="s2.user">
                  {{s2?.user?.username}}
                </div>
                <div class="name" *ngIf="!s2.user">
                  {{'Default user' | translate}}
                </div>
                <div>
                  {{s2?.updatedAt | qmDateDistance}}
                </div>
              </div>
              <div class="comment">
                {{s2?.contentData}}
              </div>
            </div>
          </div>
          <div class="input-block" *ngIf="isActive(s)">
            <div *qmAuth="'button_write'">
              <button type="button" class="btn btn-outline-success" [disabled]="!commentText" (click)="saveComment(s._id, commentText)">
                {{'Save' | translate}}
              </button>
            </div>
            <div *qmAuth="'button_write'">
              <textarea qmAutosize class="form-control" rows="1" cols="100" style="font-size: 1.2em;" [(ngModel)]="commentText"
                        placeholder="{{'New comment' | translate}}"></textarea>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="row" *ngIf="events.length > 0">
      <div class="pagination">
        <ngb-pagination
          (pageChange)="pageChanged($event)"
          [collectionSize]="pagination.total"
          [pageSize]="pagination.limit"
          [(page)]="pagination.page"
          [rotate]="true"
          [maxSize]="10"></ngb-pagination>
        <!--<pagination [(ngModel)]="pagination.page"
                    [maxSize]="10"
                    [itemsPerPage]="pagination.limit"
                    [totalItems]="pagination.total"
                    (pageChanged)="pageChanged($event)"></pagination>-->
      </div>
    </div>
  </div>
</div>
